import PropTypes from 'prop-types';
import React from 'react';
import { Label } from 'reaxl';

/**
 *  Displays an inventory label indicating that the listing price was recently reduced
 */
function ReducedPrice(_ref) {
  let {
    label = 'Reduced Price',
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Label, Object.assign({
    "data-cmp": "reducedPrice",
    weight: "bold",
    bsStyle: "secondary"
  }, rest), label);
}
export default ReducedPrice;